import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './pieChart1.module.css';
import * as echarts from 'echarts';
import {getHzListXueqiRequest} from "../../../service/report";
import ic_checked from "../../../img/ic_checked.svg";
import ic_unchecked from "../../../img/ic_unchecked.png";
import badge from "../../../img/badge.png";
import dianzan from "../../../img/dianzan.png";
import PubSub from "pubsub-js";
var myLineChart = null;

class PieChart11 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar'
        ]);

        this.state = {
            hznum: [],
            hzsum: ''
        };

    }

    componentDidMount() {
        getHzListXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if (data.ret == '1') {
                this.setState({
                    hznum: data.data.hznum==''?[]:data.data.hznum,
                    hzsum: data.data.hzsum[0].hzsum
                });

                var list = data.data.hznum;
                var list0 = [];

                for (var i = 0; i < list.length; i++) {
                    list0.push({value: list[i].hznum, name: list[i].name, type: list[i].type})
                }

                for (var i = 0; i < list0.length; i++) {
                    if (list0[i].type == '3') {
                        list0[i].itemStyle = {color: '#c43030'}
                    }
                    if (list0[i].type == '7') {
                        list0[i].itemStyle = {color: '#d55200'}
                    }
                    if (list0[i].type == '4') {
                        list0[i].itemStyle = {color: '#0e77ae'}
                    }
                    if (list0[i].type == '5') {
                        list0[i].itemStyle = {color: '#9145a7'}
                    }
                    if (list0[i].type == '6') {
                        list0[i].itemStyle = {color: '#be8f01'}
                    }
                    if (list0[i].type == '9') {
                        list0[i].itemStyle = {color: '#5c9336'}
                    }
                }

                // 思品#c43030   type=3
                // 人文#d55200   type=7
                // 科技#0e77ae   type=4
                // 艺术#9145a7   type=5
                // 体育#be8f01   type=6
                // 社会实践#5c9336   type=9

                this.initLineBar(list0);

            }
        });

    }

    componentDidUpdate() { // 组件更新后触发

    }

    componentWillUnmount() {
        myLineChart.dispose();
    }

    initLineBar(data) {

        const option = {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: '2%',
                left: 'center',
                show: false
            },
            series: [
                {
                    // name: 'Access From',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 2,
                        borderColor: '#fff',
                        borderWidth: 2
                    },

                    // itemStyle: {
                    //     normal: {
                    //         label: {
                    //             color:'white',
                    //             show: true,
                    //             position: 'inner',
                    //             fontSize: 12,
                    //             fontWeight: 'bold',
                    //             align: "center",
                    //             formatter: function (p) { //指示线对应文字,百分比
                    //                 return p.percent.toFixed(0) + "%";//设置百分比保留几位小数
                    //             }
                    //         },
                    //         labelLine: { //指示线状态
                    //             show: true,
                    //             smooth: 0.2,
                    //             length: 10,
                    //             length2: 20
                    //         }
                    //     }
                    // },


                    label: {
                        show: false,
                        position: 'center',
                        formatter: '{d}%',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '16',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },

                    data: data
                }
            ]
        };

        myLineChart = echarts.init(document.getElementById('pieChart111'));
        myLineChart.setOption(option, true)

    }


    render() {

        return (
            <div className={styles.root}>
                <div className={styles["div-title"]}>
                    <div className={styles["text-green"]}>徽章</div>
                    <div className={styles["text-red"]}>{this.state.hzsum}</div>
                </div>


                <div className={styles.container}>
                    <div id="pieChart111" className={styles.echart}></div>
                    <div className={styles["container-right"]}>
                        {
                            this.state.hznum.map((item, index, array) => {
                                return (
                                    <div className={styles["list-item"]}>
                                        <div className={item.type == '3' ? styles["fangkuai-sipin"] :
                                            item.type == '7' ? styles["fangkuai-renwen"] :
                                                item.type == '9' ? styles["fangkuai-laodong"] :
                                                    item.type == '5' ? styles["fangkuai-yishu"] :
                                                        item.type == '4' ? styles["fangkuai-shuxue"] :
                                                            item.type == '6' ? styles["fangkuai-tiyu"] : styles["fangkuai-tiyu"]
                                        }></div>
                                        <div style={{
                                            color: item.type == '3' ? '#c43030' : item.type == '7' ? '#d55200' : item.type == '9' ? '#5c9336' :
                                                item.type == '5' ? '#9145a7' : item.type == '4' ? '#0e77ae' : '#be8f01'
                                        }}>
                                            {item.name} {item.hznum}
                                        </div>

                                    </div>
                                )
                            })
                        }

                    </div>
                </div>

            </div>
        )
    }
}


export default PieChart11;
